var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "Import_svg__[object_Object]b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F1FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "Import_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BBF8",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3386EE",
    stopOpacity: 0.2,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "4.249%",
    x2: "100%",
    y2: "95.751%",
    id: "Import_svg__[object_Object]c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB1FD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#148CFC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "Import_svg__[object_Object]d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB1FD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#148CFC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .5A7.5 7.5 0 00.5 8v34A7.5 7.5 0 008 49.5h34a7.5 7.5 0 007.5-7.5V8A7.5 7.5 0 0042 .5H8z",
    stroke: "url(#Import_svg__[object_Object]a)",
    fill: "url(#Import_svg__[object_Object]b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8A1.5 1.5 0 0119 9.5v6.499l2.5.001a1.5 1.5 0 011.5 1.5V21a1 1 0 01-1 1l-1-.001V19.5a.5.5 0 00-.41-.492L20.5 19a.5.5 0 00-.492.41L20 19.5v2.499h-1V22h-1.001L18 20a1 1 0 00-.883-.993L17 19h-2a1 1 0 00-.993.883L14 20v2.001L13 22h-3a1 1 0 01-1-1v-6.882a1 1 0 01.553-.894L13 11.5v-2A1.5 1.5 0 0114.5 8h3zm.5-8a2 2 0 012 2l.001 5.165a2.965 2.965 0 00-1.667-1.084V2.885a1.2 1.2 0 00-1.2-1.2H2.866a1.2 1.2 0 00-1.194 1.077l-.006.123V19.02a1.2 1.2 0 001.077 1.194l.123.006 4.633-.001V21.5c0 .138.012.273.034.405H2a2 2 0 01-2-2V2a2 2 0 012-2h16zm-6.5 18a.5.5 0 100 1 .5.5 0 000-1zm9-1a.5.5 0 100 1 .5.5 0 000-1zm-9-1a.5.5 0 100 1 .5.5 0 000-1zm3 0a.5.5 0 100 1 .5.5 0 000-1zm3 0a.5.5 0 100 1 .5.5 0 000-1zm-3-2a.5.5 0 100 1 .5.5 0 000-1zm3 0a.5.5 0 100 1 .5.5 0 000-1zm-6 0a.5.5 0 100 1 .5.5 0 000-1zm3-2a.5.5 0 100 1 .5.5 0 000-1zm3 0a.5.5 0 100 1 .5.5 0 000-1zm-9.293-1.286a.5.5 0 01.5.5v.643c-.26.15-.485.344-.669.57l-3.728.002a.5.5 0 01-.5-.5v-.715a.5.5 0 01.5-.5h3.897zM14.5 10a.5.5 0 100 1 .5.5 0 000-1zm3 0a.5.5 0 100 1 .5.5 0 000-1zm-6.027-2.714c.135 0 .258.053.348.14-.24.394-.39.846-.423 1.33l-.008.208V9H4.31a.5.5 0 01-.5-.5v-.714a.5.5 0 01.5-.5h7.163zm3.265-3.429a.5.5 0 01.5.5v.714a.5.5 0 01-.5.5H4.31a.5.5 0 01-.5-.5v-.714a.5.5 0 01.5-.5h10.428z",
    transform: "translate(14 15)",
    fill: "url(#Import_svg__[object_Object]c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.282 0H8a8 8 0 018 8v6.718c0 .446-.046.607-.134.77a.909.909 0 01-.378.378c-.163.088-.324.134-.77.134H8a8 8 0 01-8-8V1.282C0 .836.046.675.134.512A.909.909 0 01.512.134C.675.046.836 0 1.282 0z",
    fill: "url(#Import_svg__[object_Object]d)",
    transform: "translate(34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.924 9.017l-3.998 2.855a.514.514 0 01-.812-.418v-1.342c-2.54-.284-4.618-2.608-5.103-4.56a.447.447 0 01.16-.45.452.452 0 01.632.059 5.007 5.007 0 004.31 1.91V5.743a.514.514 0 01.813-.418l3.998 2.855a.514.514 0 010 .837z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default ForwardRef;